module.exports = __webpack_public_path__ + "static/media/SPG.b86b201a.svg";